import React, { Component, Fragment } from "react";
import styled from "styled-components";
import ReactButton from "common-components/Buttons";
import { media } from "utils/style";
import CommonContainer from "common-components/Container";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { convertStringToElements } from "@vds/html-parsers";
import { setA11yContent } from "../../NavigationHelper/actions";
import { checkNestedObject } from "utils/checkNestedObject";
import FetchPageContent from "../../../../hoc/FetchPageContent";
import { setBreadcrumbList } from "common-components/BreadCrumbs/actions"
import { sendSecurePinToDevice } from "../../FormerCustomer/actions/commonFormerCustomerAPI";
import RectangleLoader from "common-components/RectangleLoader/RectangleLoader";
import { encryptData } from "utils/decryptData";
import FallbackUI from "../../FallbackUI/FallbackUI";
import StyledLink from "common-components/StyledLink";
import { MaxAttemptsModal } from "../../FormerCustomer/modals";

class DownloadVerification extends Component {

  state = {
    email: "",
    error: "",
    emailValidation: false,
    showMaxPasswordModal: false,
    errorCheck: true
  };

  componentDidMount() {
    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent("verify identity", this.props.pageContent.sc_pagetitle);
    }
  }

  componentDidUpdate() {
    let message;
    if (this.props.error && this.isJson(this.props.error)) {
      let errorObj = JSON.parse(this.props.error);
      if (errorObj.message && errorObj.message.length > 0) {
        message = errorObj.message.toLowerCase();
        if (this.state.errorCheck) {
          if (message.includes("maximum")) {
            this.setState({ showMaxPasswordModal: true }, () => { this.setState({ errorCheck: false }) })
          }
        }
      }
    } else if (this.props.error && !(this.isJson(this.props.error))) {
      message = this.props.error.toLowerCase();
      if (this.state.errorCheck) {
        if (message.includes("maximum")) {
          this.setState({ showMaxPasswordModal: true }, () => { this.setState({ errorCheck: false }) })
        }
      }
    }
  }

  isJson = (str) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  handleClick = () => {
    this.props.sendSecurePinToDevice(encryptData(this.props.emailId)).then(() => {
      if (!this.props.error) {
        let authToken = this.props.location.state.authToken;
        this.props.history.push({
          pathname: "/privacy/your-data/guest-download/" + authToken,
          state: {
            page: "otp",
            authToken: authToken
          }
        });
      }
    })
  }

  closeMaxAttemptsModal = () => {
    this.setState({ showMaxAttemptsModal: false })
    let authToken = this.props.location.state.authToken;
    let navigationtoLandingPage = "/privacy/your-data/guest-download/" + authToken;
    return this.props.history.push(navigationtoLandingPage);
  }

  render() {
    const { pageContent, loading, maxPasswordsModal } = this.props;
    if (!pageContent) {
      return <FallbackUI />;
    }

    if (loading) {
      return <RectangleLoader id={"downloadLoader"} />;
    }

    return (
      <Fragment>
        <Container>
          <H1>{pageContent.section_title}</H1>
          <Div>
            {convertStringToElements(pageContent.section_description)}
          </Div>
          <Button
            style={{ marginTop: "45px" }}
            background={pageContent.buttons[0].type}
            onClick={() => { this.handleClick() }}
          >
            {pageContent.buttons[0].text}
          </Button>
          {(this.props.error || this.state.error) && (
            this.state.showMaxPasswordModal ?
              <MaxAttemptsModal
                modalContent={maxPasswordsModal}
                closeModal={this.closeMaxAttemptsModal}
              />
              :
              null
          )}
        </Container>
      </Fragment>
    );
  }
}


DownloadVerification.propTypes = {
  setA11yContent: PropTypes.func.isRequired,
  pageContent: PropTypes.object
};

const mapStateToProps = ({
  pageContent: { request_code: pageContent, maximum_attempts_reached },
  loadingAndErrorState,
  downloadAndDelete: { emailId },
}) => ({
  pageContent,
  maxPasswordsModal: maximum_attempts_reached,
  loading: loadingAndErrorState.loading,
  error: loadingAndErrorState.error,
  emailId
});

export default compose(
  connect(
    mapStateToProps,
    { setA11yContent, setBreadcrumbList, sendSecurePinToDevice }
  ),
  FetchPageContent
)(DownloadVerification);

const Button = styled(ReactButton)`
  margin-right: 28px;
  margin-top:44px;

  ${media.mobile`
    margin-right: 0;
  `}
`;


const Container = styled(CommonContainer)`
  margin: 0px 0px 0px 20px;
  padding: 47px 80px ;

  ${media.mobile`
    padding: 48px 16px ;
  `}
`;

const H1 = styled.h1`
  font-size: 48px;
  line-height: 48px;
  font-weight: 300;
  width: 486px;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  font-style: normal;

  ${media.mobile`
   max-width: 100%;
   font-style: normal;
   font-weight: 400;
   font-size: 32px;
    line-height: 36px;
`}

`;

const Div = styled.div`
  width: 490px;
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-size: 16px;
  line-height: 20px;
  padding-top: 32px;

  ${media.mobile`
    max-width: 100%;
    font-size: 16px;
    line-height: 20px;
    padding-top: 32px;
  `}
`;

